import { safeSessionStorage } from "./storage";

const RL_SCA_FLAG_KEY = "BT_AM_SCA_SUCCEED";

export const getSingleClickFlag = () =>
  safeSessionStorage.get(RL_SCA_FLAG_KEY) === "true";

export const saveSingleClickFlag = (flag: boolean) =>
  safeSessionStorage.set(RL_SCA_FLAG_KEY, flag.toString());

export const deleteSingleClickFlag = () =>
  safeSessionStorage.remove(RL_SCA_FLAG_KEY);
